import api from '@/lib/api';

/**
 * Messenger + Instagram (Meta Graph API) — Einstellungen.
 *
 * WhatsApp'ın kardeşi: gelen DM'ler ticket olur (channel 'messenger' |
 * 'instagram'), agent cevabı ticket'tan ilgili kanala döner.
 */

export interface MetaMessagingConfig {
  page_id: string | null;
  /** Immer maskiert ("[HIDDEN]") oder null. */
  page_access_token: string | null;
  app_secret: string | null;
  ig_account_id: string | null;
  /** Vom Server generiert — bei Meta als Verify-Token eintragen. */
  verify_token: string | null;
  display_name: string | null;
  is_active: boolean;
  last_test_at?: string | null;
  last_test_status?: string | null;
  last_test_error?: string | null;
}

export interface MetaMessagingSettings {
  connected: boolean;
  enabled: boolean;
  config: MetaMessagingConfig;
  webhookUrl: string;
}

const metaService = {
  async getSettings(organizationId?: string): Promise<MetaMessagingSettings> {
    const { data } = await api.get('/meta/settings', { params: organizationId ? { organizationId } : {} });
    return data.data;
  },

  async saveSettings(payload: Partial<MetaMessagingConfig>, organizationId?: string): Promise<MetaMessagingSettings> {
    const { data } = await api.put('/meta/settings', { ...payload, ...(organizationId ? { organizationId } : {}) });
    return data.data;
  },

  async testSettings(organizationId?: string): Promise<{ success: boolean; error: string | null; pageName?: string }> {
    const { data } = await api.post('/meta/settings/test', organizationId ? { organizationId } : {});
    return data.data;
  },
};

export default metaService;
